<!-- <app-spinner [show]="isLoading.status || isLoading.rooms || isLoading.latestStatus" [size]="150"> </app-spinner> -->
<div class="host-page">
<header class="host-hero">
  <p class="host-kicker">Seller studio</p>
  <h1 class="host-heading">Host Portal</h1>
  <p class="host-sub">Create draws, ship prizes, and track settlements from one place.</p>
</header>

<ng-template #refundsPage>
  <div class="refunds-page">
    <div class="refunds-toolbar">
      <div class="refunds-toolbar__copy">
        <p class="refunds-kicker">Disputes</p>
        <h2 class="refunds-title">Refund Status</h2>
      </div>
      <mat-form-field
        class="refunds-room-field"
        appearance="outline"
        *ngIf="roomsList !== undefined && roomsList.length > 0">
        <mat-label>Webinar room</mat-label>
        <mat-select (selectionChange)="getRefundStatusByRoomId($event.value)" [formControl]="refundStatusRoomIdControl">
          <mat-option *ngFor="let room of roomsList" [value]="room.webinarRoomId">{{room.roomName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="refunds-empty" *ngIf="refundPaymentInfo !== undefined && refundPaymentInfo.length === 0">
      <mat-icon>verified</mat-icon>
      <h3>No refunds for this room</h3>
      <p>When a winner is refunded, the transaction will land here.</p>
    </div>

    <article class="refund-tile" *ngFor="let refund of refundPaymentInfo; let i = index;">
      <div class="refund-tile__top">
        <div class="refund-tile__copy">
          <span class="refund-tile__label">Transaction</span>
          <h3 class="refund-tile__id">{{ refund.transactionId }}</h3>
          <span class="refund-tile__time">{{ refund.paymentTime | date: 'dd MMM yyyy h:mm a' }}</span>
        </div>
        <div class="refund-tile__money">
          <span class="refund-tile__amount">${{ formatCurrency(refund.refundAmount) }}</span>
          <span class="refund-tile__mode" *ngIf="refund.refundMode">{{ refund.refundMode }}</span>
        </div>
      </div>

      <button
        type="button"
        class="refund-refresh"
        (click)="getLatestRefundStatusByTransactionId(refund.transactionId, i)"
        matTooltip="Check latest status"
        matTooltipShowDelay="0">
        <span class="refund-refresh__glyph" aria-hidden="true">
          <mat-icon>sync</mat-icon>
        </span>
        <span>Check status</span>
      </button>

      <div
        class="refund-status"
        *ngIf="currentRefundStatus[i] || refund.paymentStatusMaster?.paymentStatus"
        [attr.data-tone]="refundStatusTone(refundStatusLabel(currentRefundStatus[i], refund))">
        <span class="refund-status__badge">{{ refundStatusLabel(currentRefundStatus[i], refund) }}</span>
        <div class="refund-status__facts" *ngIf="currentRefundStatus[i]">
          <div *ngIf="currentRefundStatus[i].trantype">
            <span>Type</span>
            <strong>{{ currentRefundStatus[i].trantype }}</strong>
          </div>
          <div *ngIf="currentRefundStatus[i].result && currentRefundStatus[i].result !== currentRefundStatus[i].status">
            <span>Gateway result</span>
            <strong>{{ currentRefundStatus[i].result }}</strong>
          </div>
          <div *ngIf="currentRefundStatus[i].created">
            <span>Gateway time</span>
            <strong>{{ currentRefundStatus[i].created | date: 'dd MMM yyyy h:mm a' }}</strong>
          </div>
          <div *ngIf="currentRefundStatus[i].authcode">
            <span>Auth</span>
            <strong>{{ currentRefundStatus[i].authcode }}</strong>
          </div>
        </div>
      </div>

      <mat-accordion class="refund-orders" *ngIf="orderItemsParsedJson[i]?.length">
        <mat-expansion-panel class="refund-order-panel">
          <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-panel-title>
              <span class="refund-orders__mark" aria-hidden="true">
                <mat-icon>confirmation_number</mat-icon>
              </span>
              <span class="refund-orders__heading">
                <span class="refund-orders__kicker">Prize tickets</span>
                <span class="refund-orders__title">Order details</span>
              </span>
            </mat-panel-title>
            <mat-panel-description>{{ orderItemsParsedJson[i]?.length || 0 }} item{{ (orderItemsParsedJson[i]?.length || 0) === 1 ? '' : 's' }}</mat-panel-description>
          </mat-expansion-panel-header>
          <div class="refund-order-list">
            <article class="refund-order" *ngFor="let order of orderItemsParsedJson[i]; let index = index;">
              <span class="refund-order__index">{{ index + 1 }}</span>
              <div class="refund-order__copy">
                <span class="refund-order__kicker">Webinar prize</span>
                <strong>{{ orderName(order) }}</strong>
                <span class="refund-order__seat">Seat {{ orderSeat(order) }}</span>
              </div>
              <span class="refund-order__amount">${{ formatCurrency(orderAmount(order)) }}</span>
            </article>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </article>
  </div>
</ng-template>
<mat-card class="matCardHostPortal host-shell" style="margin-bottom: 50px;">
  <mat-card-content>
    <div *ngIf="!isMobileView">
      <mat-tab-group
        class="host-portal-tabs"
        [disablePagination]="false"
        [mat-stretch-tabs]="false"
        fitInkBarToContent
        (selectedIndexChange)="tabChange($event)"
        [(selectedIndex)]="selectedTab">
        <mat-tab label="New Webinar" style="color: white;">
          <div   *ngIf="createWebinar">
    
           <app-create-webinar [webinarId]="webinarId"></app-create-webinar>
          </div>
    
          </mat-tab>
        <mat-tab label="My Webinar Queue" style="color: white;">
          <div   *ngIf="webinarQueue">
          <app-my-webinar-queue  [hostRoom]="roomsList" (EditWebinar)="EditWebinar($event)" ></app-my-webinar-queue>
        </div>
        </mat-tab>
        <mat-tab label="My Configuration Page" style="color: white;">
          <div   *ngIf="configuration && roomsList !== undefined && roomsList.length > 0">
          <app-my-configuration [hostRoom]="roomsList"></app-my-configuration>
        </div>
        </mat-tab>
       
        <mat-tab label="My Stats" style="color: white;">
          <div    *ngIf="stats">
          <app-my-stats></app-my-stats>
        </div>
        </mat-tab>
        <mat-tab label="My Shipments" style="color: white;">
          <div   *ngIf="shipments">
                    <app-my-shipments></app-my-shipments>
                  </div>
        </mat-tab>
        <mat-tab label="Webinar Data" style="color: white;">
          <div   *ngIf="webinarHistorical">
          <app-webinar-historical [webinarRooms]="roomsList"></app-webinar-historical>
        </div>
        </mat-tab>
        <mat-tab label="Out Of Office" style="color: white;">
          <div   *ngIf="outOfOffice">
          <app-out-of-office></app-out-of-office>
        </div>
        </mat-tab>
        <mat-tab label="Refund Status">
          <ng-container *ngTemplateOutlet="refundsPage"></ng-container>
        </mat-tab>
        <mat-tab label="Payments">
          <div class="payments-page">
            <div class="payments-toolbar">
              <div class="payments-toolbar__copy">
                <p class="payments-kicker">Payouts</p>
                <h2 class="payments-title">Payments</h2>
              </div>
              <mat-form-field
                class="payments-room-field"
                appearance="outline"
                *ngIf="roomsList !== undefined && roomsList.length > 0">
                <mat-label>Webinar room</mat-label>
                <mat-select (selectionChange)="GetPaymentDetails($event.value)" [formControl]="paymentRoomIdControl">
                  <mat-option *ngFor="let room of roomsList" [value]="room.webinarRoomId">{{room.roomName}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="pay-tiles">
              <button type="button" class="pay-tile pay-tile--account" (click)="onPaymentAction('paymentDetails')">
                <span class="pay-tile__icon" aria-hidden="true"><mat-icon>account_balance</mat-icon></span>
                <span class="pay-tile__copy">
                  <span class="pay-tile__label">Bank account</span>
                  <span class="pay-tile__title">Update details</span>
                </span>
              </button>

              <button type="button" class="pay-tile pay-tile--ready" (click)="onPaymentAction('settlementDetails')">
                <span class="pay-tile__icon" aria-hidden="true"><mat-icon>payments</mat-icon></span>
                <span class="pay-tile__copy">
                  <span class="pay-tile__label">Ready to settle</span>
                  <span class="pay-tile__amount">${{ formatCurrency(readyForSettlement) }}</span>
                  <span class="pay-tile__meta">Pending ${{ formatCurrency(pendingForSettlement) }}</span>
                </span>
              </button>

              <button type="button" class="pay-tile pay-tile--settled" (click)="onPaymentAction('alreadySettled')">
                <span class="pay-tile__icon" aria-hidden="true"><mat-icon>verified</mat-icon></span>
                <span class="pay-tile__copy">
                  <span class="pay-tile__label">Already settled</span>
                  <span class="pay-tile__amount">${{ formatCurrency(alreadySettledAmount) }}</span>
                </span>
              </button>
            </div>
          </div>
          <br>
          <div *ngIf="actionMessage !== '' && actionMessage !== null && actionMessage !== undefined" class="withdrawConfirm">
            {{actionMessage}} <br>
            <button type="button" class="host-cta host-cta--plain" (click)="onPaymentAction('withdraw')" style="margin-top: 10px;">
              I Confirm to Withdraw $95
            </button>
          </div>
  
          <div *ngIf="showAccountDetails">
            <app-host-account-detail></app-host-account-detail>
          </div>
  
          <div *ngIf="showSettlementDetails">
            <div  style="width: 99%;">
              <div class="grid-container">
                <div class="grid-item" *ngFor="let settlement of details; let i = index;">
              <div class="matCard mat-elevation-z4" >
                  <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6">
                              Webinar Name : <span class="contentCls"> {{settlement?.webinarName}}</span>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6">
                              Seats Sold : <span class="contentCls"> {{settlement?.seatsSold}}</span>
                          </div>                         
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Seats Remaining : <span class="contentCls"> {{settlement?.seatsRemainingToBeSold}}</span>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Pending For Settlement : <span class="contentCls amount-green"> ${{settlement?.pendingForSettlement.toFixed(2)}}</span>
                          </div>                                                   
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Platform Charges : <span class="contentCls">  {{settlement?.platformChargePercentage}}% </span>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Ready For Settlement : <span class="contentCls amount-green"> ${{settlement?.readyForSettlement.toFixed(2)}}</span>
                          </div>                                                   
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Platform Charges Amount : <span class="contentCls">  {{settlement?.platformChargesAmount.toFixed(2)}} </span>
                          </div>    
                          <div class="col-sm-12 col-md-6 col-lg-6">
                            Amount To Be Settled After Platform Charges Deduction : <span class="contentCls amount-green"> ${{settlement?.toBeSettledAmountAfterPlatformChargesDeduction.toFixed(2)}}</span>
                          </div>                                                                            
                        </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
            </div>
          </div>
  
          <span *ngIf="settledWebinars !== undefined && settledWebinars.length === 0 && showSettledWebinars" class="host-empty-note">
            **Nil settled webinars.
          </span>
          <div *ngIf="showSettledWebinars && settledWebinars !== undefined">
            <div  style="width: 99%;">
              <div class="grid-container">
                <div class="grid-item" *ngFor="let settlement of settledWebinars;">
              <div class="matCard mat-elevation-z4"  >
                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          Transaction No : <span class="contentCls"> {{settlement.transactionNumber}}</span>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          Settled Amount : <span class="contentCls amount-green">  ${{settlement?.settledAmount.toFixed(2)}}</span>
                        </div>
                        
                      </div>
                      <div class="row">  
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          settledOn : <span class="contentCls"> {{settlement?.settledOn | date: 'dd MMM yyyy h.mm.ss a'}}</span>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          Settlement Proof :
                          <button type="button" class="proof-chip" (click)="onOpenSettlementProof(settlement.image)" *ngIf="settlement.image">
                            <img class="proof-chip__img" [src]="'data:image/png;base64,' + settlement.image" alt="" />
                            <span>View proof</span>
                          </button>
                        </div>    
                         
                      </div> 
                      <div class="row">                         
                        <div class="col-12">
                          Webinar Name : <span class="contentCls"> {{settlement.webinar.name}}</span>
                        </div>
                        
                      </div>
                    </div>
                     
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          
        </mat-tab>
      </mat-tab-group>
    </div>


    
    <div *ngIf="isMobileView">
      <mat-form-field appearance="outline">
        <mat-label>Select Host Portal Option</mat-label>
        <mat-select [(ngModel)]="selectedOptionToViewForMobile" (selectionChange)="onChangeHostMobielViewOption($event.value)">
          <mat-option value="NewWebinar">
            <span *ngIf="webinarId > 0; else addWebinar"> Edit Webinar</span>
            <ng-template #addWebinar> New Webinar</ng-template>
          </mat-option>
          <mat-option value="MyWebinarQueue">My Webinar Queue</mat-option>
          <mat-option value="MyConfigurationPage">My Configuration Page</mat-option>
          <mat-option value="MyStats">My Stats</mat-option>
          <mat-option value="MyShipments">My Shipments</mat-option>
          <mat-option value="WebinarData">Webinar Data</mat-option>
          <mat-option value="OutOfOffice">Out Of Office</mat-option>
          <mat-option value="RefundStatus">Refund Status</mat-option>
          <mat-option value="Payments">Payments</mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="selectedOptionToViewForMobile === 'NewWebinar'">
        <div style="margin-top: -25px;">
          <app-create-webinar [webinarId]="webinarId"></app-create-webinar>
        </div>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'MyWebinarQueue'">
        <app-my-webinar-queue [hostRoom]="roomsList" (EditWebinar)="EditWebinar($event)" ></app-my-webinar-queue>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'MyConfigurationPage' && roomsList !== undefined && roomsList.length > 0">
        <app-my-configuration [hostRoom]="roomsList"></app-my-configuration>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'MyStats'">
        <app-my-stats></app-my-stats>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'MyShipments'">
        <app-my-shipments></app-my-shipments>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'WebinarData'">
        <app-webinar-historical [webinarRooms]="roomsList"></app-webinar-historical>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'OutOfOffice'">
        <app-out-of-office></app-out-of-office>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'RefundStatus'">
        <ng-container *ngTemplateOutlet="refundsPage"></ng-container>
      </div>

      <div *ngIf="selectedOptionToViewForMobile === 'Payments'">
        <div class="payments-page">
          <div class="payments-toolbar">
            <div class="payments-toolbar__copy">
              <p class="payments-kicker">Payouts</p>
              <h2 class="payments-title">Payments</h2>
            </div>
          </div>
          <div class="pay-tiles">
            <button type="button" class="pay-tile pay-tile--account" (click)="onPaymentAction('paymentDetails')">
              <span class="pay-tile__icon" aria-hidden="true"><mat-icon>account_balance</mat-icon></span>
              <span class="pay-tile__copy">
                <span class="pay-tile__label">Bank account</span>
                <span class="pay-tile__title">Update details</span>
              </span>
            </button>
            <button type="button" class="pay-tile pay-tile--ready" (click)="onPaymentAction('settlementDetails')">
              <span class="pay-tile__icon" aria-hidden="true"><mat-icon>payments</mat-icon></span>
              <span class="pay-tile__copy">
                <span class="pay-tile__label">Ready to settle</span>
                <span class="pay-tile__amount">${{ formatCurrency(readyForSettlement) }}</span>
                <span class="pay-tile__meta">Pending ${{ formatCurrency(pendingForSettlement) }}</span>
              </span>
            </button>
            <button type="button" class="pay-tile pay-tile--settled" (click)="onPaymentAction('alreadySettled')">
              <span class="pay-tile__icon" aria-hidden="true"><mat-icon>verified</mat-icon></span>
              <span class="pay-tile__copy">
                <span class="pay-tile__label">Already settled</span>
                <span class="pay-tile__amount">${{ formatCurrency(alreadySettledAmount) }}</span>
              </span>
            </button>
          </div>
        </div>

        <div *ngIf="actionMessage !== '' && actionMessage !== null && actionMessage !== undefined" class="withdrawConfirm">
          {{actionMessage}} <br>
          <button type="button" class="host-cta host-cta--plain" (click)="onPaymentAction('withdraw')" style="margin-top: 10px;">
            I Confirm to Withdraw $95
          </button>
        </div>

        <div *ngIf="showAccountDetails">
          <app-host-account-detail></app-host-account-detail>
        </div>

        <div *ngIf="showSettlementDetails">
          <div  style="width: 99%;">
            <div class="matCard mat-elevation-z4" style="background-color: whitesmoke;margin-top: 5px;" *ngFor="let settlement of details; let i = index;">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Webinar Name : <span class="contentCls"> {{settlement?.webinarName}}</span>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Seats Sold : <span class="contentCls"> {{settlement?.seatsSold}}</span>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Seats Remaining : <span class="contentCls"> {{settlement?.seatsRemainingToBeSold}}</span>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Pending For Settlement : <span class="contentCls amount-green"> ${{settlement?.pendingForSettlement.toFixed(2)}}</span>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Platform Charges : <span class="contentCls">  {{settlement?.platformChargePercentage}}% </span>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Ready For Settlement : <span class="contentCls amount-green"> ${{settlement?.readyForSettlement.toFixed(2)}}</span>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            Platform Charges Amount : <span class="contentCls">  {{settlement?.platformChargesAmount.toFixed(2)}} </span>
                        </div>
                        <div class="col-sm-12 col-md-8 col-lg-8">
                            Amount To Be Settled After Platform Charges Deduction : <span class="contentCls amount-green"> ${{settlement?.toBeSettledAmountAfterPlatformChargesDeduction.toFixed(2)}}</span>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <span *ngIf="settledWebinars !== undefined && settledWebinars.length === 0 && showSettledWebinars" class="host-empty-note">
          <br>
          **Nil already settled webinars found.
        </span>
        <div *ngIf="showSettledWebinars && settledWebinars !== undefined">
          <div  style="width: 99%;">
            <div class="matCard mat-elevation-z4" style="background-color: whitesmoke;margin-top: 5px;" *ngFor="let settlement of settledWebinars;">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row">
                      <div class="col-sm-12 col-md-5 col-lg-5">
                        Transaction No : <span class="contentCls"> {{settlement.transactionNumber}}</span>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3">
                        Settled Amount : <span class="contentCls amount-green">  ${{settlement?.settledAmount.toFixed(2)}}</span>
                      </div>
                      <div class="col-sm-12 col-md-4 col-lg-4">
                        settledOn : <span class="contentCls"> {{settlement?.settledOn | date: 'dd MMM yyyy h.mm.ss a'}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row">
                      <div class="col-sm-12 col-md-8 col-lg-8">
                         Settlement Proof :
                         <button type="button" class="proof-chip" (click)="onOpenSettlementProof(settlement.image)" *ngIf="settlement.image">
                          <img class="proof-chip__img" [src]="'data:image/png;base64,' + settlement.image" alt="" />
                          <span>View proof</span>
                         </button>
                      </div>
                      <div class="col-sm-12 col-md-4 col-lg-4">
                        Webinar Name : <span class="contentCls"> {{settlement.webinar.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

    </div>
    
  </mat-card-content>
</mat-card>
</div>
